import { FaMicrophone, FaStop, FaVolumeUp } from 'react-icons/fa';
import { VOICE_LISTENING_HINT, VOICE_NOT_SUPPORTED_MSG } from '../utils/voiceLanguages';
import './VoiceMicButton.css';

/**
 * Reusable microphone button for voice-first search and booking.
 */
const VoiceMicButton = ({
  isListening = false,
  isSpeaking = false,
  isSupported = true,
  language = 'en',
  onToggle,
  onStopSpeaking,
  size = 'md',
  variant = 'default',
  showHint = false,
  className = '',
  disabled = false,
  title,
}) => {
  const handleClick = () => {
    if (disabled) return;
    if (isSpeaking && onStopSpeaking) {
      onStopSpeaking();
      return;
    }
    if (!isSupported) {
      alert(VOICE_NOT_SUPPORTED_MSG[language] || VOICE_NOT_SUPPORTED_MSG.en);
      return;
    }
    onToggle?.();
  };

  const ariaLabel = isListening
    ? 'Stop listening'
    : isSpeaking
      ? 'Stop speaking'
      : 'Start voice input';

  return (
    <div className={`voice-mic-wrap ${className}`.trim()}>
      <button
        type="button"
        className={`voice-mic-btn voice-mic-btn--${size} voice-mic-btn--${variant}${
          isListening ? ' voice-mic-btn--listening' : ''
        }${isSpeaking ? ' voice-mic-btn--speaking' : ''}${!isSupported ? ' voice-mic-btn--unsupported' : ''}`}
        onClick={handleClick}
        disabled={disabled}
        aria-label={ariaLabel}
        aria-pressed={isListening}
        title={title || (isListening ? 'Stop listening' : 'Speak to search or book')}
      >
        {isSpeaking ? (
          <FaVolumeUp className="voice-mic-icon voice-mic-icon--pulse" />
        ) : isListening ? (
          <FaStop className="voice-mic-icon" />
        ) : (
          <FaMicrophone className="voice-mic-icon" />
        )}
        {isListening && <span className="voice-mic-pulse" aria-hidden="true" />}
      </button>
      {showHint && isListening && (
        <span className="voice-mic-hint" role="status">
          {VOICE_LISTENING_HINT[language] || VOICE_LISTENING_HINT.en}
        </span>
      )}
    </div>
  );
};

export default VoiceMicButton;
